import React, { Fragment } from 'react';
import { Container, Grid, Table, Card, Page, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import { formatDate } from '../../lib/helpers';
import { useParams } from 'react-router-dom';

const shipmentHeaders = ["Name", "Pick Up", "Destination", "Shipment Type", "Status", "Created At", "Arrival Date"];

const TripMatchedShipments = () => {
  const { id } = useParams()
  const { data, loading } = useFetch(`trips/${id}/matched-shipments`);
debugger
  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Trip Matched Shipments</Page.Title>
        </Page.Header>
        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <Form.Input
                      icon="search"
                      placeholder="Search for..."
                      position="append"
                    />
                  </Card.Options>
                </Card.Header>
                {!loading && data.length < 1 ?
                  <div className="alert alert-primary m-0">
                    No Shipments to show!
                  </div> :
                  <>
                    <Table
                      hasOutline
                      striped
                    >
                      <Table.Header>
                        {shipmentHeaders.map((head, i) => (
                          <Table.ColHeader
                            key={`tableHeader-${i}`}
                          >
                            {head}
                          </Table.ColHeader>
                        ))}
                      </Table.Header>
                      <Table.Body>
                        {data && data.map(({ name, fromCity, toCity, shipmentType, state, createdAt, shipmentArrivalDate }, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              {name}
                            </Table.Col>

                            <Table.Col>
                              {fromCity.name}
                            </Table.Col>

                            <Table.Col>
                              {toCity.name}
                            </Table.Col>

                            <Table.Col>
                              {shipmentType}
                            </Table.Col>

                            <Table.Col>
                              {state}
                            </Table.Col>

                            <Table.Col>
                              {formatDate(new Date(createdAt))}
                            </Table.Col>

                            <Table.Col>
                              {formatDate(new Date(shipmentArrivalDate))}
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </>
                }
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}
export default TripMatchedShipments;